export const PROFILE_WALLPAPER_STYLES = [
  "FILL",
  "GRADIENT_LINEAR_UP",
  "GRADIENT_LINEAR_DOWN",
  "BLUR",
] as const;

export type ProfileWallpaperStyle = (typeof PROFILE_WALLPAPER_STYLES)[number];
export type ProfileThemeType = "PRESET" | "CUSTOM";

export const PROFILE_THEME_COLORS = [
  "#FF5722",
  "#2563EB",
  "#7C3AED",
  "#16A34A",
  "#DB2777",
  "#111827",
] as const;

export interface ProfileTheme {
  id: string;
  type: ProfileThemeType;
  name: string;
  themeColor: string;
  titleTextColor: string;
  bioTextColor: string;
  backgroundColor: string;
  wallpaperStyle: ProfileWallpaperStyle;
  buttonColor: string;
  buttonTextColor: string;
}

export type ProfileThemeColorField =
  | "backgroundColor"
  | "buttonColor"
  | "buttonTextColor"
  | "bioTextColor"
  | "titleTextColor";

export const DEFAULT_PROFILE_TITLE_TEXT_COLOR = "#111827";
export const DEFAULT_PROFILE_BIO_TEXT_COLOR = "#4B5563";
export const DEFAULT_PROFILE_BACKGROUND_COLOR = "#FF5722";
export const DEFAULT_PROFILE_WALLPAPER_STYLE: ProfileWallpaperStyle =
  "GRADIENT_LINEAR_DOWN";
export const DEFAULT_PROFILE_BUTTON_COLOR = "#FFFFFF";
export const DEFAULT_PROFILE_BUTTON_TEXT_COLOR = "#1F2937";

export const DEFAULT_PROFILE_THEME: ProfileTheme = {
  id: "default",
  type: "PRESET",
  name: "Default",
  themeColor: "#FF5722",
  titleTextColor: DEFAULT_PROFILE_TITLE_TEXT_COLOR,
  bioTextColor: DEFAULT_PROFILE_BIO_TEXT_COLOR,
  backgroundColor: DEFAULT_PROFILE_BACKGROUND_COLOR,
  wallpaperStyle: DEFAULT_PROFILE_WALLPAPER_STYLE,
  buttonColor: DEFAULT_PROFILE_BUTTON_COLOR,
  buttonTextColor: DEFAULT_PROFILE_BUTTON_TEXT_COLOR,
};

export function applyProfileColor(
  theme: ProfileTheme,
  field: ProfileThemeColorField,
  color: string,
): ProfileTheme {
  return {
    ...theme,
    type: "CUSTOM",
    name: "Custom",
    ...(field === "backgroundColor" ? { themeColor: color } : {}),
    [field]: color,
  };
}

export function applyProfileWallpaperStyle(
  theme: ProfileTheme,
  wallpaperStyle: ProfileWallpaperStyle,
): ProfileTheme {
  return {
    ...theme,
    type: "CUSTOM",
    name: "Custom",
    wallpaperStyle,
  };
}

export function getProfileWallpaperBackground(
  color: string,
  style: ProfileWallpaperStyle,
): string {
  if (style === "FILL") {
    return color;
  }

  if (style === "GRADIENT_LINEAR_UP") {
    return `linear-gradient(0deg, ${color}, ${color}99)`;
  }

  if (style === "BLUR") {
    return color;
  }

  return `linear-gradient(180deg, ${color}, ${color}99)`;
}

export function getProfileWallpaperBlurBackground(color: string): string {
  return `linear-gradient(135deg, ${color}, ${color}66)`;
}
